// removed by extract-text-webpack-plugin
module.exports = {"workersCcusConnectConfirmDialog":"vh--TeVDm-hWhnNX-c5Cs","refetchCompleteDialog":"_1ax29gp2DHhm6u1QZS8hXN","ccusConnectErrorDialog":"_2IOouXlq3bIfDUGalInCDz","ccusConnectErrorMessage":"_1-OKjAH9kMt91-BFA3cJpL","ccusSecededMessage":"_3sujiRCqoWGGptXl9QGVt2"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/worker/workerInfo/worker-info.scss
// module id = 1482
// module chunks = 0